import OccasionalTrackingSummaryItem from 'models/occasional-tracking-summary-item.model';
import occasionalTrackingApi from 'service/occasional-tracking-api';

export const fetchOccasionalTrackingListUseCase = async companyId => {
  const { packages } = await occasionalTrackingApi.list(companyId);
  return packages?.map(OccasionalTrackingSummaryItem.parseApiResponse);
};

export default { fetchOccasionalTrackingListUseCase };
